import {agent} from "./MBA/agent";

const {createString,createObject} = require('../shared');
const {basicMil} = require('./MBA/basicMil');
const {basicMilSpouse} = require('./MBA/basicMilSpouse');
const {coverage} = require('./MBA/coverage');
const {declarations} = require('./MBA/declarations');
const {dependents} = require('./MBA/dependents');
const {health} = require('./MBA/health');
const {beneficiaries} = require('./MBA/beneficiaries');
const {payment} = require('./MBA/payment');

module.exports.milMBA = function (inData, outData) {
  const {req, formData} = inData;
  outData = {status: false, person: req.person, type: req.type, error: null, data: {}};
  let appData = {};

  if (!outData.error && !createString(appData, "type", req.type)) {
    outData.error = "Cannot set application type";
  }

  // basic info
  if (req.person === "primary") {
    basicMil(appData, formData, outData);
  } else if (req.person === "spouse") {
    basicMilSpouse(appData, formData, outData);
  } else {
    outData.error = "Person not implemented in Mil MBA";
  }

  //declarations
  if (req.person === "primary") {
    declarations(appData, formData, outData, "primary");
  } else if (req.person === "spouse") {
    declarations(appData, formData, outData, "spouse");
  } else {
    outData.error = "Person not implemented in Mil MBA";
  }

  //Coverage
  coverage(appData, formData, outData, "primary");

  //Dependents
  if (req.person === "primary") {
    dependents(appData, formData, outData);
  } else {
    if (!outData.error && !createObject(appData, "dependents", [])) {
      outData.error = "Cannot create dependent info";
    }
  }

  //Health
  if (req.person === "primary") {
    health(appData, formData, outData, 'health');
  } else if (req.person === "spouse") {
    health(appData, formData, outData, 'spouseHealth');
  } else {
    outData.error = "Person not implemented in Mil MBA";
  }


  //Beneficiaries
  if (req.person === "primary") {
    beneficiaries(appData, formData, outData, 'beneficiary');
  } else if (req.person === "spouse") {
    beneficiaries(appData, formData, outData, 'spouseBeneficiary');
  } else {
    outData.error = "Person not implemented in Mil MBA";
  }

  //Payments
  payment(appData, formData, outData);

  //Agent Info
  agent(appData, formData, outData);

  outData.data = appData;
  return outData;
}


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/milMBA.js